export default __webpack_public_path__ + "static/media/HAB1.0581c6b1.jpg";